export const TRANSACTIONS = '/transactions';
